module.exports = __webpack_public_path__ + "static/media/tix.e6105e5c.svg";